import { Component, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/_services';

@Component({
  selector: 'app-custom-clipboard-copy-input',
  templateUrl: './custom-clipboard-copy-input.component.html',
  styleUrls: ['./custom-clipboard-copy-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomClipboardCopyInputComponent),
      multi: true
    }
  ]
})
export class CustomClipboardCopyInputComponent implements OnInit, ControlValueAccessor {

  @Input() showPassword?: boolean = true;
  @Input() isPasswordMode: boolean = true;
  passwordControl: FormControl = new FormControl('');
  @Output() inputValue = new EventEmitter<string>();
  @ViewChild('copyTooltip') copyTooltip: NgbTooltip;

  private onChange: (value: any) => void = () => { };
  private onTouch: () => void = () => { };

  constructor(
  ) { }

  ngOnInit() {

  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  copyInputMessage(inputElement: HTMLInputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);

    this.showTooltip();
    setTimeout(() => {
      this.hideTooltip();
    }, 1000);
  }

  showTooltip() {
    this.copyTooltip.open();
  }

  hideTooltip() {
    this.copyTooltip.close();
  }

  sendInputValue(event) {
    this.onChange((event.target as HTMLInputElement).value);
    this.onTouch();
  }

  writeValue(passwordValue: string): void {
    if (typeof passwordValue === 'string') {
      this.passwordControl.setValue(passwordValue);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void { }

}
